import { render, staticRenderFns } from "./workDuty.vue?vue&type=template&id=74efb712&scoped=true"
import script from "./workDuty.vue?vue&type=script&lang=js"
export * from "./workDuty.vue?vue&type=script&lang=js"
import style0 from "./workDuty.vue?vue&type=style&index=0&id=74efb712&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74efb712",
  null
  
)

export default component.exports